// Slice 1E (Fulfillment): a thin "do I have intake forms waiting on me?"
// probe that the SalesDailyChecklistWidget renders inline.
//
// Gates (composed at the call site, not here):
//   - The caller restricts to sales-role users; per the locked scope
//     decision G4, non-sales fillers don't get a nag.
//   - The caller ANDs in `auth.hasSalesFloor` (Fulfillment Slice 3,
//     replaces the original `VITE_FULFILLMENT_PILOT` env flag) so the
//     nag is hidden on manufacturer-only orgs without a sales floor.
//
// The hook itself is intentionally minimal -- it does one GET on mount
// and returns the count. The widget already has its own refresh button
// the user can use; a passive nag is fine.

import { useEffect, useState } from "react";
import { getFulfillmentIntakePendingCount } from "@/lib/fulfillment/fulfillmentApi";

export type FulfillmentIntakeNagModel = {
  enabled: boolean;
  count: number | null;
};

export function useFulfillmentIntakeNag(enabled: boolean): FulfillmentIntakeNagModel {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void (async () => {
      const r = await getFulfillmentIntakePendingCount();
      if (cancelled) return;
      if (!r.ok) {
        setCount(null);
        return;
      }
      setCount(r.data.count);
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return { enabled, count };
}
